import Link from 'next/link'
import { useRouter } from 'next/router'

import { H4, Text } from '../../styles/typography'
import Button from '../button'
import ViewTracker from '../tracking/view-tracker'
import { SubscriptionUpsellEl } from './elements'

const SubscriptionUpsell = () => {
  const { asPath } = useRouter()

  return (
    <SubscriptionUpsellEl>
      <ViewTracker item='recommended classes' page={asPath} />

      <div className='graphic' />

      <H4>LivDemy Pro</H4>
      <Text>
        LivDemy is a next generation music learning platform that provides 250
        hours of high-quality music lessons from celebrities to help you become
        an expert in your favorite genres.
      </Text>
      <Text>
        There are over 1000+ video lessons available 24/7. You will also be able
        to attend live session with these celebrities on a regular basis.
      </Text>

      <div className='actions'>
        <Link href='/pricing' passHref>
          <a>
            <Button theme='primary'>Become a LivDemy Pro</Button>
          </a>
        </Link>
      </div>
    </SubscriptionUpsellEl>
  )
}

export default SubscriptionUpsell
